/* Modulacción Baños — Datos detallados de los 4 proyectos destacados.
   Fotografías arquitectónicas y datos técnicos / narrativa al estilo de webs
   de construcción industrial (Boffi, B&B Italia, Antonio Lupi, Porcelanosa). */

export const PROJECTS = [
  {
    slug: "suite-marble-hotel-boutique",
    title: "Suite Marble",
    subtitle: "Hotel Boutique · Madrid",
    place: "Madrid, España",
    year: "2024",
    sector: "Hospitality · 5★",
    hero: "https://images.unsplash.com/photo-1638799869566-b17fa794c4de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBiYXRocm9vbXxlbnwwfHx8fDE3Nzg2NTU1NjV8MA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1758548157466-7c454382035a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBiYXRocm9vbXxlbnwwfHx8fDE3Nzg2NTU1NjV8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1587749158407-58ef2b89ccf8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxtYXJibGUlMjB0ZXh0dXJlJTIwc2xhYnxlbnwwfHx8fDE3Nzg2NTU1NjV8MA&ixlib=rb-4.1.0&q=85",
    ],
    summary:
      "44 suites premium para un hotel boutique de cinco estrellas en el centro histórico de Madrid. Cada baño en mármol Carrara bookmatched, entregado e instalado en una operativa nocturna de cuatro semanas, sin interrumpir el servicio del hotel ni alterar la actividad del barrio.",
    metrics: [
      { k: "44", v: "módulos · suites" },
      { k: "28 días", v: "instalación en obra" },
      { k: "−68%", v: "plazo vs. obra tradicional" },
      { k: "0", v: "incidencias post-entrega" },
    ],
    challenge:
      "Edificio protegido en pleno casco antiguo: ventanas estrechas, escaleras históricas y ordenanza municipal que prohíbe ruido en horario diurno. Cualquier solución tradicional habría exigido cerrar el hotel ocho meses.",
    solution:
      "Diseñamos un módulo Suite (6.8 m²) en mármol Carrara con instalaciones pre-conectadas y reforzamos la estructura interior para reducir su peso un 22%. Maniobra nocturna con grúa torre micro, una planta por jornada y un único oficio en obra: el instalador Modulacción.",
    materials: ["Mármol Carrara bookmatched", "Latón cepillado", "Vidrio templado 10 mm", "Microcemento crudo"],
    team: [
      { role: "Promotor", name: "Grupo Hotelero MD" },
      { role: "Arquitectura", name: "Estudio Lamela & Asociados" },
      { role: "Construcción", name: "Modulacción Baños" },
    ],
    quote: {
      text: "Nunca habríamos abierto en septiembre sin Modulacción. Recuperamos seis meses de calendario y la calidad final es indistinguible de la obra tradicional, simplemente mejor.",
      author: "Helena R. — Director de operaciones, Grupo Hotelero MD",
    },
  },

  {
    slug: "industrial-loft-bath",
    title: "Industrial Loft Bath",
    subtitle: "Residencial premium · Barcelona",
    place: "Barcelona, España",
    year: "2024",
    sector: "Residencial unifamiliar",
    hero: "https://images.unsplash.com/photo-1733425992462-0f674e744ead?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwaW5kdXN0cmlhbCUyMGJhdGhyb29tfGVufDB8fHx8MTc3ODY1NTU1Mnww&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1632324875014-b5713099bef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxjb25jcmV0ZSUyMHRleHR1cmUlMjB3YWxsfGVufDB8fHx8MTc3ODY1NTU2NXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1635247049694-0269c357ab69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwaW5kdXN0cmlhbCUyMGJhdGhyb29tfGVufDB8fHx8MTc3ODY1NTU1Mnww&ixlib=rb-4.1.0&q=85",
    ],
    summary:
      "Loft de 220 m² en una antigua fábrica textil del Poblenou. Dos módulos contemporáneos en microcemento monolítico que conservan la huella industrial del edificio sin renunciar al confort doméstico.",
    metrics: [
      { k: "2", v: "módulos · principal + invitados" },
      { k: "9 días", v: "instalación en obra" },
      { k: "−74%", v: "tiempo vs. obra húmeda" },
      { k: "A+", v: "calificación energética" },
    ],
    challenge:
      "Cliente arquitecto, exigencia máxima de acabado y rechazo absoluto del tabique tradicional: quería materia continua, sin juntas ni rodapiés. La obra húmeda tradicional habría tardado tres meses y dejado el loft inhabitable.",
    solution:
      "Módulo Estándar (4.5 m²) revestido en microcemento autonivelante de planta, con ducha abierta enrasada y mobiliario suspendido en acero negro mate. Estructura monolítica preparada para apoyarse sobre la solera original de hormigón sin demoliciones.",
    materials: ["Microcemento monolítico gris", "Acero pavonado", "Vidrio extra-claro", "Roble ahumado"],
    team: [
      { role: "Cliente", name: "Privado" },
      { role: "Arquitectura", name: "Estudio MN Architects" },
      { role: "Construcción", name: "Modulacción Baños" },
    ],
    quote: {
      text: "Buscaba un baño que pareciera tallado de una sola pieza. Modulacción me lo entregó literalmente así, en un camión, una mañana de marzo.",
      author: "Marc N. — Cliente y arquitecto",
    },
  },

  {
    slug: "co-living-compact",
    title: "Co-living Compact",
    subtitle: "Residencia compartida · Valencia",
    place: "Valencia, España",
    year: "2023",
    sector: "Co-living · 96 unidades",
    hero: "https://images.unsplash.com/photo-1635247049694-0269c357ab69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwaW5kdXN0cmlhbCUyMGJhdGhyb29tfGVufDB8fHx8MTc3ODY1NTU1Mnww&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1636063522013-8d8fbfe8fcdc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxwcmVmYWIlMjBiYXRocm9vbSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3Nzg2NTU1NTJ8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1760237655540-8197ef24838b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHx3b29kJTIwdGV4dHVyZSUyMGludGVyaW9yfGVufDB8fHx8MTc3ODY1NTU2NXww&ixlib=rb-4.1.0&q=85",
    ],
    summary:
      "Promoción de 96 unidades de co-living para jóvenes profesionales. Reto: amortizar al máximo cada metro útil, sin que el baño pareciera de obra de coste contenido. Producción en serie, percepción artesanal.",
    metrics: [
      { k: "96", v: "módulos compactos" },
      { k: "11 sem", v: "fabricación total" },
      { k: "3.2 m²", v: "superficie útil por baño" },
      { k: "−42%", v: "coste vs. presupuesto inicial" },
    ],
    challenge:
      "El promotor traía un presupuesto cerrado por baño un 30% por debajo del estándar de mercado, pero exigía que el acabado pasara una inspección comercial de gama media-alta. La planta húmeda tradicional, con 96 unidades, era una pesadilla logística.",
    solution:
      "Módulo Compacto (3.2 m²) en porcelánico XL imitación piedra clara y mobiliario en roble cepillado. Línea de fabricación dedicada con 8 unidades semanales y entrega a obra a razón de 12 módulos por viaje. Un único equipo de instalación de tres personas durante 16 semanas.",
    materials: ["Porcelánico XL piedra clara", "Roble cepillado FSC", "Grifería empotrada", "Vidrio mate"],
    team: [
      { role: "Promotor", name: "Atlantis Living" },
      { role: "Arquitectura", name: "Estudio Vora" },
      { role: "Construcción", name: "Modulacción Baños" },
    ],
    quote: {
      text: "Industrializar 96 baños y que ninguno tenga aspecto industrial. Eso es lo que entregaron, y por eso vamos a repetir en las dos próximas promociones.",
      author: "Sergio C. — CEO, Atlantis Living",
    },
  },

  {
    slug: "residencial-premium",
    title: "Residencial Premium",
    subtitle: "Promoción residencial · Bilbao",
    place: "Bilbao, España",
    year: "2025",
    sector: "Residencial multifamiliar",
    hero: "https://images.unsplash.com/photo-1636063522013-8d8fbfe8fcdc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxwcmVmYWIlMjBiYXRocm9vbSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3Nzg2NTU1NTJ8MA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1758548157466-7c454382035a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBiYXRocm9vbXxlbnwwfHx8fDE3Nzg2NTU1NjV8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1733425992462-0f674e744ead?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwaW5kdXN0cmlhbCUyMGJhdGhyb29tfGVufDB8fHx8MTc3ODY1NTU1Mnww&ixlib=rb-4.1.0&q=85",
    ],
    summary:
      "Promoción de 38 viviendas de obra nueva en la ría de Bilbao con dos baños por unidad. La operación más ambiciosa de Modulacción hasta la fecha: 76 módulos personalizados en tres tipologías que comparten ADN material pero responden a programas distintos.",
    metrics: [
      { k: "76", v: "módulos · 38 viviendas" },
      { k: "3", v: "tipologías diferentes" },
      { k: "5 meses", v: "fabricación + entrega" },
      { k: "100%", v: "entregas a tiempo" },
    ],
    challenge:
      "El proyecto exigía variar la distribución y el tamaño según la planta y la orientación, manteniendo coherencia visual entre todas las viviendas. La obra tradicional habría multiplicado oficios, supervisión y plazos por tres.",
    solution:
      "Tres familias de módulo (Compacto · Estándar · Suite) compartiendo paleta material — roble + microcemento + grifería negra mate — y diferenciadas por escala y programa. Producción escalonada en planta y entrega just-in-time, sincronizada al avance de la estructura del edificio.",
    materials: ["Roble cepillado", "Microcemento off-white", "Grifería acero negro mate", "Cerámica artesanal"],
    team: [
      { role: "Promotor", name: "Promociones Bilbao Sur" },
      { role: "Arquitectura", name: "Estudio Mecanismo" },
      { role: "Construcción", name: "Modulacción Baños + Constructora local" },
    ],
    quote: {
      text: "76 baños, tres tipologías, cero retrasos. Modulacción nos demostró que se puede industrializar lo singular.",
      author: "Iñigo A. — Director de obra, Promociones Bilbao Sur",
    },
  },
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);
